import { Spinner } from 'src/app/core/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { SrmService } from 'src/app/shared/service/srm.service';

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss']
})
export class GeneralSettingsComponent implements OnInit {

  supplierFileName = '';
  supplierFile = '';
  internalFileName = '';
  internalFile = '';

  @ViewChild ('file') file;
  @ViewChild ('file1') file1;
  constructor(
    private toastr: ToastrService,
    private spinner: Spinner,
    private srmService: SrmService
  ) { }

  ngOnInit() {
  }

  onSelectFile(event, name) { // called each time file input changes
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size > 10485760) {
        this.toastr.error(
          MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
        );
        return;
      }
      // const fileType = file.name.split('.')[file.name.split('.').length - 1];
      // console.log(fileType);
      // if (fileType.search('pdf') === -1) {
      //   this.toastr.error(
      //     MESSAGE_TOAST.FILE_TYPE_WRONG
      //   );
      //   return;
      // }
      if (name === 'external') {
        this.supplierFileName = file.name;
        this.supplierFile = file;
      } else {
        this.internalFileName = file.name;
        this.internalFile = file;
      }
    }
  }

  save(name) {
    let file = '';
    if (name === 'external' && this.supplierFile) {
      file = this.supplierFile;
    } else if (this.internalFile) {
      file = this.internalFile;
    }
    if (file) {
      this.spinner.show();
      this.srmService.uploadRatingGuileLine(file, name).subscribe(res => {
        this.spinner.hide();
        this.toastr.success(MESSAGE_TOAST.UPLOAD_RATING_GUIDELINE);
        if (name === 'external') {
          this.file.nativeElement.value = '';
        } else {
          this.file1.nativeElement.value = '';
        }
      });
    }
  }

}
